"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultOptions = {
  padWithZero: true
};

/**
 * Retrieves the minutes component of a given date, formatted based on the specified options.
 *
 * @param {Time} date - The date to retrieve minutes from.
 * @param {MinuteOptions} [options=defaultOptions] - Options for configuring the minute format.
 * @returns {string | number} - The minutes (e.g., "01", "02" for padded, or 1, 2 for unpadded).
 *
 * @example
 * const minutesPadded = getMinute(new Date(), { padWithZero: true }) // e.g., "03"
 * const minutesUnpadded = getMinute(new Date(), { padWithZero: false }) // e.g., 3
 */
function getMinute(date) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    padWithZero
  } = _objectSpread(_objectSpread({}, defaultOptions), options);
  const minutes = date.getMinutes();
  return padWithZero ? minutes.toString().padStart(2, '0') : minutes.toString();
}
var _default = exports.default = getMinute;